import React from 'react'
import FormLink from "../../../../library/form/components/FormLink";
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormButton from '../../../../library/form/components/FormActionButton2';

const BomMaterialRow = (props) => {
    const { formObject, index, rowKey } = props;

    // console.log('Material Row item',viewData.rowValues.item.valF);
    return (
        <ul className="uiDPEditLine">
            <li className="uiColumnCenter uiColumn50">
                <span>{index}</span>
            </li>
            <li className="uiColumnCenter uiColumn100">
                <FormROValue useVal={true} format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "actualItem" }} />
            </li>
            <li className="uiColumnCenter uiColumn250">
            <FormLink formObject={formObject} 
                            rowKey={rowKey} className="uiLink uiSpacerH5" anchorStyle={{width:"75%"}}
                            action={{
                                paramName: "actualItem",
                                actionId: "show", actionName: "itemComp",
                                containerKey: "custom",
                                actionParam:{
                                    showModeID: "qv"
                                }
                            }}
                            linkProp={{ target: "_blank" }}
                        ></FormLink>
            </li>
            <li className="uiColumnCenter uiColumn100">
                <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "nickName" }} />
            </li>
            <li className="uiColumnCenter uiColumn90">
                <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "unit" }} />
            </li>
            <li className="uiColumnCenter uiColumn90">
                <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "estQty" }} />
            </li>
            <li className="uiColumnCenter uiColumn90">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "calculatedUnitCost" }} />
            </li>
            <li className="uiColumnCenter uiColumn90">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "estValue" }} />
            </li>
            <li className="uiColumnCenter uiColumn200">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "comment" }} />
            </li>
            <li className="uiColumnCenter uiColumn50">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "sih" }} />
            </li>
            <li className="uiColumnCenter uiColumn60 uiActionBlock">
                <FormButton formObject={formObject} rowKey={rowKey}
                    starIcon="edit"
                    onlyIcon={true}
                    tooltip="Edit"
                    starIconClassName="uiColorNeutralAction"
                            action={{ actionId: "edit",  
                            paramName: "editBtn",
                            actionParam: {pathKey: "OEXI"}, containerKey: "popup" }}
                            className="" ></FormButton>
                <FormButton formObject={formObject} rowKey={rowKey}
                    starIcon="clear"
                    onlyIcon={true}
                    tooltip="Delete"
                    starIconClassName="uiColorNegativeAction"
                        action={{ actionId: "del",  
                        paramName: "delBtn",
                        actionParam: {pathKey: "OEXI"}, containerKey: "row" }}
                        className="" ></FormButton>
            </li>
        </ul>
    )
}

export default BomMaterialRow